import { ChartColumn } from './ChartColumn';

import './Chart.scss';

export type BarData = {
  index: number;
  showLookupIcon: boolean;
  date?: Date;
  empty?: boolean;
  heightProportion?: number;
  outlier?: boolean;
  selectable?: boolean;
  scaleValue?: number | string;
  ariaLabel?: string;
  price?: number | null;
};

type ChartProps = {
  chartIdentifier: string;
  barsData?: Array<BarData & { ariaLabel: string }>;
  onBarClick?: (index: number) => void;
  maxColumnWidthPercent?: number;
  selectedIndex?: number | null;
  scaleValueFormatter?: (value: number | string) => string;
};

const EMPTY_BARS: Array<BarData & { ariaLabel: string }> = [];
const defaultScaleValueFormatter = (value: number | string) => `${value}`;

export const Chart = ({
  barsData = EMPTY_BARS,
  chartIdentifier,
  maxColumnWidthPercent = 100,
  onBarClick = () => {},
  scaleValueFormatter = defaultScaleValueFormatter,
  selectedIndex = null,
}: ChartProps) => (
  <div id={chartIdentifier} className="bar-chart">
    {barsData.map((dayData) => (
      <ChartColumn
        {...dayData}
        maxWidthPercent={maxColumnWidthPercent}
        onClick={onBarClick}
        key={dayData.index}
        selected={dayData.index === selectedIndex}
        scaleValueFormatter={scaleValueFormatter}
        ariaLabel={dayData.ariaLabel}
      />
    ))}
  </div>
);
